import { SectionHeading } from "../components/SectionHeading";
import { Reveal } from "../components/Reveal";
import { WHY_MODORS } from "../data/site";

const SPANS = ["md:col-span-2", "", "", "md:col-span-2", "", ""];

export const WhyModors = () => (
  <section id="why-modors" data-testid="why-modors-section" className="bg-brand-coal py-24 sm:py-32 relative overflow-hidden">
    <div className="absolute inset-0 noise-overlay opacity-[0.06] pointer-events-none" />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
      <SectionHeading
        dark
        kicker="The MODORS Standard"
        title="Why MODORS?"
        desc="Six reasons builders, contractors and dealers across Delhi NCR specify MODORS frames."
      />
      <div className="mt-14 grid md:grid-cols-3 gap-px bg-white/10 border border-white/10">
        {WHY_MODORS.map((c, i) => (
          <Reveal key={c.num} delay={(i % 3) * 0.08} className={`bg-brand-coal ${SPANS[i]}`}>
            <div
              data-testid={`why-modors-card-${i}`}
              className="group relative h-full p-7 sm:p-9 border border-transparent hover:border-brand-red/60 transition-colors duration-300"
            >
              <span className="font-display text-5xl font-semibold text-white/10 group-hover:text-brand-red/40 transition-colors duration-300">
                {c.num}
              </span>
              <h3 className="mt-5 font-display text-xl font-semibold uppercase tracking-wide text-white">
                {c.title}
              </h3>
              <p className="mt-3 text-sm text-white/55 leading-relaxed max-w-md">{c.desc}</p>
              <span className="absolute top-0 left-0 h-[2px] w-0 bg-brand-red group-hover:w-full transition-[width] duration-500" />
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
